<template>
  <div id="home" class="homeDiv">
    <table width="100%">
      <tr>
        <td class="tc">
          <div>
            <span>
              <h1>
                <font color="#6d6e7d" size="16" face="黑体">中国消防协会会员管理系统</font>
              </h1>
            </span>
          </div>
          <br>
          <div>
            <img src="../../../static/images/home/home.png" style="width:100%; max-width:693px;">
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: "home",
  data() {
    return {
      //当前登陆用户
      currentUser: this.CONSTANT.currentUser
    };
  },
  created() {
    let vm = this;
    vm.$parent.dialogVisible = true;
    var passwordChgFlag = vm.currentUser.passwordChgFlag;
    if (passwordChgFlag == "F") {
      vm.$alert(
        "为保证信息安全，请点击右上角用户名，前往用户中心，按照密码校验规则修改密码",
        '提示',
        {
          confirmButtonText: '确定',
          type: 'warning'
        });
    }
  },
  methods: {}
};
</script>

<style>
.homeDiv {
  vertical-align: middle;
  display: inline-block;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/home/HomeUser.vue